import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { StackModule } from '../stack/stack.module';

import { CardContentComponent } from './card-content.component';

@NgModule({
  declarations: [CardContentComponent],
  imports: [CommonModule, StackModule],
  exports: [CardContentComponent],
})
export class CardContentModule { }